export default __webpack_public_path__ + "static/media/hellfirebreath.e6a1be0e.png";